import clsx from 'clsx'
import * as TooltipPrimitive from '@radix-ui/react-tooltip'
import { useState, type ReactNode } from 'react'

import { ReactComponent as InfoIcon } from '../assets/svgs/info.svg'

type InfoProps = {
  children: ReactNode
}

export const Tooltip = ({ children }: InfoProps) => {
  const [isOpen, setIsOpen] = useState(false)

  const handleTriggerClick = () => {
    setIsOpen((prevState) => !prevState)
  }

  return (
    <TooltipPrimitive.Provider disableHoverableContent>
      <TooltipPrimitive.Root open={isOpen} onOpenChange={setIsOpen} disableHoverableContent>
        <TooltipPrimitive.Trigger asChild onClick={handleTriggerClick}>
          <button type="button">
            <InfoIcon
              fontSize={16}
              stroke={isOpen ? '#2C3E50' : undefined}
              className={clsx('transition', {
                'bg-[#4a7d9a50] overflow-hidden rounded-full': isOpen,
                'bg-transparent': !isOpen,
              })}
            />
          </button>
        </TooltipPrimitive.Trigger>
        <TooltipPrimitive.Portal>
          <TooltipPrimitive.Content
            align="start"
            alignOffset={-8}
            sideOffset={4}
            side="bottom"
            className="max-w-[198px] md:relative md:max-w-sm px-2 py-1 rounded-lg shadow-lg outline-none bg-primary-light"
          >
            <p className="text-sm text-white">{children}</p>
            <TooltipPrimitive.Arrow className="fill-primary-light" />
          </TooltipPrimitive.Content>
        </TooltipPrimitive.Portal>
      </TooltipPrimitive.Root>
    </TooltipPrimitive.Provider>
  )
}
